import IssuesList from './IssuesList';

export default IssuesList;
